import { BrowserRouter, Switch, Route } from "react-router-dom";
import { ROUTES } from "./routes";
import DefaultLayout from "./components/default-layout";

import Home from "./screens/home/home";
import Transaction from "./screens/transaction";

import "./styles.scss";
import Manual from "./screens/manual";
import { useSelector } from "react-redux";
import useStartup from "./hooks/startup";
import { useEffect } from "react";
import TransactionHistory from "./screens/history";
import Status from "./screens/status";

const App = () => {
  const { loader, isMaintenance } = useSelector((state: any) => state.bridge);
  const {} = useStartup();
  if (isMaintenance) {
    return (
      <div className="h-screen flex justify-center items-center flex-col">
        
        <div  className={" flex justify-center items-center mb-10 gap-4"}>
          <img className={"w-36"} src={"/svgs/maintenance.png"} />
          <img className={"w-96 bg-dark px-4 py-2 rounded-2xl"} src={"/svgs/logo.svg"} />
              
        </div>
        <p className="px-4 flex flex-col item text-6xl font-extrabold"><span>Under Maintenance</span></p>  
      </div>
    );
  }
  if (loader) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <div className={"lds-roller"}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }
  return (
    <BrowserRouter>
      <Switch>
        <DefaultLayout>
          <Route path={ROUTES.default} exact children={<Home />} />
          <Route path={ROUTES.manual} exact children={<Manual />} />
          <Route path={ROUTES.history} children={<TransactionHistory />} />
          <Route path={ROUTES.transaction} children={<Transaction />} />
          <Route path={ROUTES.status} children={<Status />} />
        </DefaultLayout>
      </Switch>
    </BrowserRouter>
  );
};

export default App;
